import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './App.css'; // Estilos
import { HelmetProvider } from 'react-helmet-async'; // ✅ Import necesario

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
